
import { Link } from "react-router-dom";
import { 
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";

export const BenefitsDropdown = () => {
  return (
    <NavigationMenu>
      <NavigationMenuList>
        <NavigationMenuItem>
          <NavigationMenuTrigger className="font-inter text-secondary-dark hover:text-primary transition-colors bg-transparent hover:bg-transparent">
            Benefits
          </NavigationMenuTrigger>
          <NavigationMenuContent>
            <ul className="grid w-[400px] gap-3 p-4 md:w-[500px] md:grid-cols-2">
              <li className="row-span-2">
                <NavigationMenuLink asChild>
                  <Link to="/secondary-glazing-benefits" className="block select-none space-y-1 rounded-md bg-gradient-to-b from-accent/50 to-accent p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground">
                    <div className="text-lg font-medium text-white">All Benefits</div>
                    <p className="line-clamp-2 text-sm leading-snug text-white opacity-90">
                      Discover all the advantages of secondary glazing for your property.
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink asChild>
                  <Link to="/noise-reduction-secondary-glazing" className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground">
                    <div className="text-sm font-medium leading-none">Noise Reduction</div>
                    <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                      Up to 80% noise reduction for peaceful living.
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink asChild>
                  <Link to="/thermal-insulation-secondary-glazing" className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground">
                    <div className="text-sm font-medium leading-none">Energy Efficiency</div>
                    <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                      Save up to 20% on heating bills with better insulation.
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink asChild>
                  <Link to="/heritage-preservation-secondary-glazing" className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground">
                    <div className="text-sm font-medium leading-none">Heritage Preservation</div>
                    <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                      Maintain character while improving performance.
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink asChild>
                  <Link to="/secondary-glazing-cost" className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground">
                    <div className="text-sm font-medium leading-none">Cost Benefits</div>
                    <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                      Affordable alternative to full window replacement.
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
            </ul>
          </NavigationMenuContent>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
};
